import React, {useState, useEffect, useMemo} from 'react';
import clsx from 'clsx';
import {flatMap, groupBy, includes, isEmpty, mapValues, sortBy, uniqBy, values} from "lodash";
import ProductSpecsDisplay from "../../GroupItems/ProductSpecsDisplay";
import Modal from "../../../../Modals/Modal";
import {pluralize} from "../../../../lib/TextHelpers";

export default function ClusterSpecsTableAdapter({
  cluster = {}, clusterState = {}, allProductSpecs = []
}) {

  const specsByProduct = useMemo(() => {
    return groupBy(
      flatMap(allProductSpecs, 'specs'),
      'productId'
    );
  }, [allProductSpecs]);

  const {matchingProducts = {}} = clusterState;
  const productList = uniqBy(sortBy(values(matchingProducts), x => x.sku), 'sku');
  const productCount = productList.length;

  if (!canShowSpecs({clusterState, cluster}))
    return null;


  // show only if product count is exactly oone!
  if (isEmpty(allProductSpecs) || (productCount !== 1))
    return null;

  return <ProductSpecsDisplay
    productList={productList}
    allProductSpecs={allProductSpecs}
    />
}

function canShowSpecs({clusterState, cluster}) {
  const {matchingProducts = {}, selections} = clusterState;

  const {levels = []} = cluster;  // array like [fitment style colour]

  if (isEmpty(matchingProducts)) return false;

  const missingLevels = levels.filter(l => !selections[l]);

  if (includes(missingLevels, 'fitment'))
    return false;

  return true;
}
